import { AnimatePresence, motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";

const Dialog = ({ children, showDialog, title, onClose, injectClass = '' }) => {
    const close = () => {
        if (typeof onClose === 'function') onClose();
    }

    return (
        <AnimatePresence>
            {showDialog && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[900] flex items-center justify-center bg-slate-950/55 px-4 py-6 backdrop-blur-sm"
                    onClick={close}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 24, scale: 0.98 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 20, scale: 0.98 }}
                        transition={{ duration: 0.2 }}
                        className={`panel-card flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden px-6 py-5 text-tColor ${injectClass}`}
                        onClick={(event) => event.stopPropagation()}
                    >
                        <motion.div className="flex items-start justify-between gap-4 border-b border-borderColor pb-4">
                            <div>
                                <p className="text-xs font-bold uppercase tracking-[0.2em] text-tpColor">Action Panel</p>
                                <h3 className="mt-1 text-xl font-semibold text-tColor">{title}</h3>
                            </div>
                            <button
                                type="button"
                                className="flex h-10 w-10 items-center justify-center rounded-full border border-borderColor text-tpColor transition hover:border-primeColor/40 hover:text-primeColor"
                                onClick={close}
                            >
                                <IoMdClose size="20px" />
                            </button>
                        </motion.div>
                        <motion.div className="mt-5 overflow-auto">{children}</motion.div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

export default Dialog
